// extracted by mini-css-extract-plugin
export default {"glossary":"style_glossary__iSLTy"};